/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';

// Hide console logs in production
if (environment.production) {
  enableProdMode();

  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.info = () => {};
  console.debug = () => {};
}

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    const loader = document.getElementById('global-loader');

    if (loader) {
      loader.style.display = 'none';
    }
  })
  .catch((err) => console.error(err));